import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'

import 'swiper/css'
Swiper.use([Navigation, Pagination, Autoplay])

const enableSwipers = function () {
  document.querySelectorAll('.swiper.featured-content-slider').forEach((el) => {
    let paginationEl = el.querySelector('.swiper-pagination')
    let navigationPrev = el.querySelector('.swiper-button-prev')
    let navigationNext = el.querySelector('.swiper-button-next')
    let autoplaySetting = el.getAttribute('data-autoplay')
    let featuredNavTitle = el.querySelector(
      '.featured-content-slider__nav-title'
    )
    let featuredNavSlug = el.querySelector('.featured-content-slider__nav-slug')
    let spaceBetweenMobile = parseInt(el.getAttribute('data-space-between'))
    let spaceBetweenDesktop = parseInt(0)
    let autoplayConfig

    if (spaceBetweenMobile != 0) {
      spaceBetweenMobile = 24
      spaceBetweenDesktop = spaceBetweenMobile + 8
    }

    if (autoplaySetting == 'true') {
      autoplayConfig = {
        delay: 5000,
        pauseOnMouseEnter: true,
      }
    } else {
      autoplayConfig = false
    }

    let swiper = new Swiper(el, {
      autoplay: autoplayConfig,
      freemode: true,
      preloadImages: false,
      loop: true,
      centeredSlides: true,
      slidesPerView: 1.2,
      spaceBetween: 16,
      watchSlidesProgress: true,
      speed: 600,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        767: {
          spaceBetween: 32,
          freemode: false,
          slidesPerView: 2.5,
          centeredSlides: true,
        },
      },
      navigation: {
        prevEl: navigationPrev,
        nextEl: navigationNext,
      },
      on: {
        transitionStart: function () {
          featuredNavTitle.classList.remove('active')
          featuredNavSlug.classList.remove('active')
          this.pagination.render()
          this.pagination.update()
        },
        transitionEnd: function () {
          let index = this.activeIndex
          let title = this.slides[index].dataset.title
          let slug = this.slides[index].dataset.slug
          let url = this.slides[index].dataset.url
          if (title) {
            featuredNavTitle.setAttribute('href', url)
            featuredNavTitle.innerHTML = title
            featuredNavTitle.classList.add('active')
          }
          if (slug) {
            featuredNavSlug.innerHTML = slug
            featuredNavSlug.classList.add('active')
          }
        },
      },
    })
  })
}

enableSwipers()

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    enableSwipers()
  })
}
